import React, { useEffect, useState } from 'react'
import TitleBar from './parts/TitleBar'
import { Link } from 'react-router-dom'
import YouTubeVideo from './parts/YouTubeVideo'
import illustBtn from '../img/parts/button/illustBtn.png'
import illustBtn_2 from '../img/parts/button/illustBtn_2.png'
import massageBtn from '../img/parts/button/massageBtn.png'
import eventBtn from '../img/parts/button/eventBtn.png'
import hokuroBtn from '../img/parts/button/hokuroBtn.png'
import Footer from './parts/Footer'

const Home = () => {
  return (
    <div className="relative flex h-screen flex-col overflow-hidden">
      <header>
        <TitleBar />
      </header>
      <div className=" relative  flex-grow overflow-auto text-center">
        <YouTubeVideo />
        <div className="mx-auto items-center justify-center lg:flex lg:w-2/3">
          <Link to={'/nemo2024/message'}>
            <MessageIcon />
          </Link>
          <Link to={'/nemo2024/illust'}>
            <IllustIcon />
          </Link>
          <Link to={'/nemo2024/event'}>
            <TLIcon />
          </Link>
          <Link to={'/nemo2024/hokuro'}>
            <HokuroIcon />
          </Link>
        </div>
      </div>
      <footer className="z-0 w-screen">
        <Footer />
      </footer>
    </div>
  )
}

export default Home

const IllustIcon = () => {
  const [boolean, setBoolean] = useState<boolean>()
  useEffect(() => {
    const getRandomBoolean = () => {
      return Math.random() < 0.5 // 0から1の範囲でランダムな数を生成し、その値が0.5未満ならtrue、それ以外ならfalseを返す
    }
    setBoolean(getRandomBoolean())
  }, [boolean])

  return (
    <div className="m-2 transform transition-transform duration-300 hover:scale-105 ">
      {/* イラスト */}
      <img src={boolean ? illustBtn : illustBtn_2} alt="イラスト" />
    </div>
  )
}
const MessageIcon = () => {
  return (
    <div className=" m-2 transform transition-transform duration-300 hover:scale-105 ">
      {/* メッセージ */}
      <img src={massageBtn} alt="メッセージ" />
    </div>
  )
}

const TLIcon = () => {
  return (
    <div className="m-2 transform transition-transform duration-300 hover:scale-105 ">
      {/* イベント */}
      <img src={eventBtn} alt="イベント" />
    </div>
  )
}

const HokuroIcon = () => {
  return (
    <div className="m-2 transform transition-transform duration-300 hover:scale-105 ">
      {/* イベント */}
      <img src={hokuroBtn} alt="イベント" />
    </div>
  )
}
